import { render, staticRenderFns } from "./SupposedToBeBook.vue?vue&type=template&id=7fed6d1e&scoped=true"
import script from "./SupposedToBeBook.vue?vue&type=script&lang=js"
export * from "./SupposedToBeBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fed6d1e",
  null
  
)

export default component.exports